import React from 'react';
import styled from '@emotion/styled';
import TextBlock from '../../components/shared/TextBlock';

const StyledContainer = styled('article')`
    width: 100%;
`;

const StyledTextBlock = styled(TextBlock)`
    max-width: 56rem;

    & p {
        margin-top: 1.6rem;
        margin-bottom: 0;
    }
`;

const CaseStudyText = ({ children }) => {
	return (
		<StyledContainer>
			<StyledTextBlock>{children}</StyledTextBlock>
		</StyledContainer>
	);
};

export default CaseStudyText;
